import { SafeHTML } from 'edrolo/domains/app';
import TemplateResponseFieldRenderer from '../TemplateResponseFieldRenderer';
import styles from './styles.scss';
/* eslint-disable react/prop-types */ // TODO: add props

const ClozeParagraphReadOnly = ({
  text,
  responseValues = [],
  exampleValues = [],
}) => (
  <p>
    <TemplateResponseFieldRenderer
      text={text}
      renderResponseField={(responseFieldIndex) => {
        const value = responseValues[responseFieldIndex];
        return value ? (
          <SafeHTML as="span" className={styles.value}>
            {value}
          </SafeHTML>
        ) : (
          <SafeHTML as="span" className={styles.missing}>
            &nbsp;
          </SafeHTML>
        );
      }}
    />
  </p>
);

export default ClozeParagraphReadOnly;
